import styles from './template.css';
import template from './template';
import {storeInstance} from '@aofl/store/dist/legacy';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import '../side-panel-sdo';
import {sdoNs} from '../../../constants-enumerate';

/**
 * @summary SidePanelButton
 * @extends {AoflElement}
 */
@customElement('side-panel-button')
class SidePanelButton extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of SidePanelButton.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.addEventListener('click', this.clickHandler);
    this.addEventListener('keypress', this.keyPressHandler);
  }

  /**
   * @readonly
   */
  static is ='side-panel-button';

  @property({type: Boolean})
  right = false;

  panelLocation = this.hasAttribute('right') ? 'right': 'left'; // eslint-disable-line no-invalid-this
  mutationId = 'set' + this.panelLocation.charAt(0).toUpperCase() + this.panelLocation.slice(1) +'Active'; // eslint-disable-line no-invalid-this
  mobileMediaQuery = window.matchMedia('(max-width: 767px)'); // eslint-disable-line no-invalid-this

  mapStateProperties() {
    const state = this.storeInstance.getState();
    const offCanvas = this.mobileMediaQuery.matches? true:
      state[sdoNs.SIDE_PANELS][this.panelLocation].offCanvas;

    if (offCanvas) {
      this.setAttribute('off-canvas', '');
    } else {
      this.removeAttribute('off-canvas');
    }
  }

  /**
   * @param {Event} e
   */
  clickHandler(e) {
    e.stopPropagation();
    const state = this.storeInstance.getState();
    const panel = state[sdoNs.SIDE_PANELS][this.panelLocation];
    if (!panel.active) {
      e.target.setAttribute('aria-expanded', 'true');
      setTimeout(() => {
        document.querySelector('site-header').shadowRoot.querySelector('left-panel').shadowRoot.querySelector('side-panel').querySelector('left-menu').shadowRoot.querySelector('[focusfirst]').focus();
      }, 150); /** @todo temporary hack - wait for drawer to open before focusing */
    } else {
      e.target.setAttribute('aria-expanded', 'false');
    }
    this.storeInstance.commit({
      namespace: sdoNs.SIDE_PANELS,
      mutationId: this.mutationId,
      payload: !panel.active
    });
  }

  keyPressHandler = (e) => {
    if (e.key === 'Enter') {
      this.clickHandler(e);
    }
  };

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default SidePanelButton;
